var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mt-8 ml-8 mr-8"},[_c('v-card-text',[_vm._v(" FA Dashboard ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }